import { useQuery } from '@tanstack/react-query';
import { dashboardApi, dashboardQueryKeys } from '../api/dashboard.api';

/**
 * "Awaiting my action" block (Stage 12). Not server-cached — items must drop
 * right after the user acts on them — so keep the client staleTime short.
 */
export function useCase360My(enabled = true) {
  return useQuery({
    queryKey: dashboardQueryKeys.case360My(),
    queryFn: () => dashboardApi.getCase360My(),
    staleTime: 30 * 1000,
    enabled,
  });
}
